import React, { useEffect, useState, useRef } from 'react';
import { useForm } from '../forms/useForm';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { ConfigServer } from "../../data/config";
import moment from 'moment';
import { useModal } from "react-morphing-modal";
import { usePaginationCash } from "../pagination/usePaginationCash";
import { getAllBranches } from '../../services/commercialLine/commercialLine'
import { getDetailCash } from '../../services/cashFlow/cashFlow'
import { createCash, getGlobalDetail } from '../../services/cashFlow/cashFlow'
import { useHistory } from 'react-router-dom';
import { labcen, cedimi, pyrsa, insan, semlab, almas, qfb, phersu } from '../../constant/globalConstantsTypeClients'
import * as XLSX from "xlsx-js-style";



export const useCash = () => {

    // * GLOBALES
    // * NEW COMMIT
    let _commercialLine = localStorage.getItem('CommercialLineShort');
    let _nameUser = localStorage.getItem('nameUser');
    let _branchName = localStorage.getItem('branchName');
    let id_branch = localStorage.getItem('branchId');
    let _type_client = localStorage.getItem('url_helen');


    const history = useHistory();



    const [viewTab, setViewTab] = useState(1);
    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    //indicadores
    const [cancell, setCancell] = useState(0);
    const [discountT, setDiscountT] = useState(0);
    const [orderFirst, setOrderFirst] = useState(0);
    const [orderLast, setOrderLast] = useState(0);
    const [idCashFlow, setIdCashFlow] = useState(0);
    const [totalCancell, setTotalCancell] = useState(0);
    //historic cash flow
    const [dataHistoric, setDataHistoric] = useState([]);
    const [dateInit, setDateInit] = useState(new moment().format('YYYY-MM-DD'));
    const [dateEnd, setDateEnd] = useState(new moment().format('YYYY-MM-DD'));
    const [typeModal, setTypeModal] = useState("ViewCas");
    const [modalC, setModalC] = useState(false);
    const [typeAmoun, setTypeAmoun] = useState([]);
    const [amountfin, setAmountfin] = useState([]);
    const [totalPaymets, setTotalPaymets] = useState(0);
    const numberCash = 8;
    const [branches, setBranches] = useState([]);
    const [dataUser, setDataUser] = useState([])
    const [sumPayMethods, setSumPayMethods] = useState(0)
    const [totalPatients, setTotalPatients] = useState(0);

    //*CONFIGURATION FINANCE
    let _valid_Finance = localStorage.getItem('finance');
    let _finance2 = localStorage.getItem('finance_view');
    let _validationFinance = (_valid_Finance === "True" && _finance2 === "False") ? true : false

    //*PRINT TICKET
    const [loadingPrint, setLoadingPrint] = useState(false);

    //*DETAIL REPORT
    const [datafinally, setDatafinally] = useState([]);
    const [dataDevolution, setDataDevolution] = useState(0);
    const [listC, setListC] = useState(0)
    const [loadingCreate, setLoadingCreate] = useState(false)

    //*PRINT TICKET
    const [modalPrint, setModalPrint] = useState(false);

    //*PREVIEW CASH
    const [modalPreview, setModalPreview] = useState(false);


    //*FINAL REPORT 
    const [dataReport, setDataReport] = useState([]);
    const [key, setKey] = useState(0);
    const [dataPaymets, setDataPaymets] = useState([]);
    const [dataCancell, setDataCancell] = useState(0);
    const [dataDiscount, setDataDiscount] = useState(0);
    const [dataPatient, setDataPatient] = useState(0);
    const [dataMDiscount, setDataMDiscount] = useState(0);
    const [total_devolution, setTotal_devolution] = useState(0)
    const [loadingReport, setLoadingReport] = useState(false)


    const [dataUserReport, setDataUserReport] = useState([]);
    const [excelExport, setExcelExport] = useState(null);
    const [globalFilter, setGlobalFilter] = useState(null)

    //? TOAST ALERT 
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState("info");
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");

    // * FLUJO B
    const [dataBonificacionCC, setDataBonificacionCC] = useState(0);



    const showToastAlert = (
        type = "info",
        title = "",
        message = ""
    ) => {

        setToastType(type);
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);

    };


    const closeToastAlert = () => {
        setShowToast(false);
        setToastTitle("");
        setToastMessage("");
    };




    useEffect(() => {
        getAmount();
        handleHistoric(true);
        getDetailCreditCash();
        getBranches();
        getUserDetail()
    }, []);

    useEffect(() => {
        if (idCashFlow > 0) {
            if (_type_client === "https://cedimi.helen-sw.com") {
                downloadExcelCredits(idCashFlow);
                downloadExcelOthers(idCashFlow);
                printTicket(idCashFlow);
            } else {
                printTicket(idCashFlow);
                downloadExcel(idCashFlow);
            }
        }
    }, [idCashFlow, _type_client]);


    const toggleCash = () => {
        setModalC(!modalC);
    }

    //*REF
    const modalFullRef = useRef(null);


    //*FORM
    const [formCash, handleInputChangeCash, resetCash, handleUpdateValuesCash, handleSelectValuesCash] = useForm({
        capture_amount: "",
        comments: "",
        mDateRange1: "",
        mDateRange2: "",
        mSelectBranch: 0,
        ids_users: 0,
        ids_branches: 0,
        type_company: null
    });

    const {
        capture_amount,
        comments,
        mDateRange1,
        mDateRange2,
        mSelectBranch,
        type_company,
        ids_users
    } = formCash;

    //*PRINT TICKET
    const toggleModalPrint = () => {
        setModalPrint(!modalPrint);
    }

    const handleViewTickets = () => {
        toggleModalPrint()
    }

    //*PREVIEW CASH 
    const toggleModalPreview = () => {
        setModalPreview(!modalPreview);
    }

    const handleViewPreview = () => {
        toggleModalPreview()
    }



    //*OPEN FINAL REPORT
    const { close, modalProps, open } = useModal({
        onClose: () => setKey(key => key + 1),
        background: "#fff"

    });

    const handleReport = () => {
        open(modalFullRef);
    }


    //*HISTORIC CASH
    const previewCash = async (nim) => {
        setTypeModal("ViewCas");
        toggleCash();
    }


    //*ACTIONS MENU
    const navigatePrev = () => {
        let tab = viewTab;
        tab = tab - 1;
        setViewTab(tab);
        handleUpdateValuesCash({
            capture_amount: 0,
            input2: "",
            input3: "",
            input4: "",
            comments: ""
        })
    };


    // ? BRANCHES
    useEffect(() => {
        if (branches.length > 0) {

            let _find = branches.find(x => x.value === parseInt(id_branch))
            handleUpdateValuesCash({
                ...formCash,
                mSelectBranch: _find
            });
        }
    }, [branches]);


    const getBranches = async () => {
        const branches = await getAllBranches();
        if (branches !== null && branches.length > 0) {
            let _allOption = {
                value: 0,
                label: "TODAS LAS SUCURSALES"
            };

            let _newBranches = [_allOption];

            branches.forEach((branch) => {
                _newBranches.push({
                    value: branch.id_branch,
                    label: branch.name
                });
            });

            setBranches(_newBranches);
        } else {
            setBranches([]);
        }
    }

    // ? REPORT GLOBAL
    const getUserDetail = async () => {
        let _mfrom = (mDateRange1) ? moment(mDateRange1).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
        let _mto = (mDateRange2) ? moment(mDateRange2).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");

        const detailAmount = await getGlobalDetail(id_branch, _mfrom, _mto);

        if (detailAmount !== null) {

            let _arrayNew = [];

            let _amountGlobal = [
                { id_pay_method: 1, pay_method: "EFECTIVO", amount: 0 },
                { id_pay_method: 2, pay_method: "TARJETA DE CRÉDITO", amount: 0 },
                { id_pay_method: 4, pay_method: "TARJETA DE DÉBITO", amount: 0 },
                { id_pay_method: 8, pay_method: "TRANSFERENCIA ELECTRÓNICA DE FONDOS", amount: 0 },
                { id_pay_method: 28, pay_method: "FICHA DE DEPOSITO", amount: 0 },
                { id_pay_method: 10, pay_method: "CREDITO", amount: 0 }
            ];

            const companyNamesMap = {};

            detailAmount.workOrderDetailCash.forEach((_find, _key) => {
                if (_valid_Finance === "True") {
                    if (_finance2 === "False") {
                        if (_find.complete_information === "True") {
                            return;
                        }
                    }
                }


                if (_find.id_user !== null && _find.id_user !== 0) {
                    const companyName = _find.user;

                    if (!companyNamesMap.hasOwnProperty(companyName)) {
                        companyNamesMap[companyName] = true;
                        const nuevo = {
                            value: _find.id_user,
                            label: companyName,
                        };
                        setDataUser(prevDataUser => [...prevDataUser, nuevo]);
                    }
                }

                let { nim, fech, name, company, status, user, id_user, ajuste, paid, fech_Adjust, fech_admision, is_invoice, name_branches, amountDiscount, id_work_order } = _find;

                let payment = {
                    creditCard: _find.nameMethod === "TARJETA DE CRÉDITO" ? _find.amount : 0,
                    cash: _find.nameMethod === "EFECTIVO" ? _find.amount : 0,
                    debitCard: _find.nameMethod === "TARJETA DE DÉBITO" ? _find.amount : 0,
                    electronicTransfer: _find.nameMethod === "TRANSFERENCIA ELECTRÓNICA DE FONDOS" ? _find.amount : 0,
                    credit: _find.nameMethod === "CREDITO" ? _find.amount : 0,
                    deposit: _find.nameMethod === "FICHA DE DEPOSITO" ? _find.amount : 0,
                };

                let existingOrderIndex = _arrayNew.findIndex(objeto => objeto.nim === _find.nim);

                if (existingOrderIndex !== -1) {
                    if (!_find.ajuste) {
                        _arrayNew[existingOrderIndex].amount += _find.amount;
                    }
                    Object.keys(payment).forEach(method => {
                        _arrayNew[existingOrderIndex][method] += payment[method];
                    });
                } else {
                    _arrayNew.push({
                        ...payment,
                        nim,
                        hour: fech,
                        namePatiente: name,
                        name_branches: name_branches,
                        type: company ? "Empresas" : "P.General",
                        status: status === 0 ? "Cancelado" : "Vigente",
                        method: _find.nameMethod,
                        amount: (!_find.ajuste ? _find.amount : 0),
                        user,
                        id_user,
                        is_fullPaid: paid === false ? "PENDIENTE" : "LIQUIDADO",
                        ajuste,
                        paid,
                        fech_Adjust,
                        fech_admision,
                        is_invoice,
                        amountDiscount, id_work_order,
                        typeClientUser: _find.is_micro ? company ? _find.name_company : name : name


                    });
                }

                Object.keys(payment).forEach(method => {
                    if (_find.status === 0) {
                        return;
                    }

                    let id_pay_method = _find.id_pay_method;
                    let methodAmount = payment[method];

                    let globalIndex = _amountGlobal.findIndex(item => item.id_pay_method === id_pay_method);

                    if (globalIndex !== -1) {
                        _amountGlobal[globalIndex].amount += methodAmount;
                    }
                });
            });
            setDataUserReport(_arrayNew);
        } else setDataUserReport([]);

    }

    //? DETAIL CASH 
    const getAmount = async () => {
        const detailAmount = await getDetailCash(id_branch);

        if (detailAmount !== null) {

            let _restTotal = 0;
            let _sum_Global = 0;

            let workOrderCash = detailAmount?.workOrderCash ?? [];

            if (_type_client === labcen) {

                const keptWorkOrders = [];

                workOrderCash = Object.values(
                    workOrderCash.reduce((acc, item) => {
                        if (!acc[item.id_work_order]) {
                            acc[item.id_work_order] = [];
                        }
                        acc[item.id_work_order].push(item);
                        return acc;
                    }, {})
                ).flatMap(group => {

                    const workOrderId = group[0].id_work_order;

                    const hasCreditPaid = group.some(x =>
                        x.id_pay_method === 10 &&
                        x.fully_paid === true
                    );

                    const adjusted = group.filter(x =>
                        x.id_pay_method !== 10 &&
                        x.indicador === true
                    );

                    if (hasCreditPaid && adjusted.length > 0) {
                        keptWorkOrders.push(workOrderId);
                        return adjusted;
                    }

                    return group;
                });

            }


            const list = workOrderCash.reduce((_delete, _find) => {
                console.log("🚀 ~ getAmount ~ _find:", _find);

                if (_find.id_pay_method === 10 && _find.fully_paid === false) {
                    _restTotal += _find.amout;
                }

                _sum_Global += _find.amout;

                _delete.push({
                    id_pay_method: _find.id_pay_method,
                    pay_method: _find.pay_method,
                    total: Math.round(_find.amout),
                    fully_paid: _find.fully_paid
                });

                return _delete;
            }, []);


            setDatafinally(list);
            setListC(_restTotal);
            setSumPayMethods(_sum_Global);
            setCancell(detailAmount?.total_work_order_cancels);
            setDiscountT(Math.round(detailAmount?.total_discounts));
            setOrderFirst(detailAmount?.id_work_order_first);
            setOrderLast(detailAmount?.id_work_order_last);
            setTotalCancell(detailAmount?.cancell);
            setDataDevolution(detailAmount?.cancellAndIva);
            setTotalPatients(detailAmount?.total_work_orders);

        } else {
            setDatafinally([]);
            setListC(0);
            setSumPayMethods(0);
            setCancell(0);
            setDiscountT(0);
            setOrderFirst(0);
            setOrderLast();
            setTotalCancell();
            setDataDevolution(0);
            setTotalPatients(0);
        }
    };


    // ? GROUP BY METHODS    
    useEffect(() => {
        if (datafinally.length >= 1) {

            let _array = datafinally;
            let _nuevoObjeto = [];
            let _indexObject = [];

            _array.forEach(x => {
                if (!_nuevoObjeto.hasOwnProperty(x.pay_method)) {
                    _nuevoObjeto[x.pay_method] = {
                        Amount: 0,
                        AmountCapture: 0,
                    }
                    _indexObject.push(x.pay_method);
                }
                _nuevoObjeto[x.pay_method].Amount = _nuevoObjeto[x.pay_method].Amount + Math.round(x.total);
            })

            setAmountfin([_nuevoObjeto])
            setTypeAmoun([..._indexObject])
        }
        else {
            setTypeAmoun([]);
            setAmountfin([]);
        }

    }, [datafinally, dataDevolution, listC])

    const [visibleTicket, setVisibleTicket] = useState(false);

    const showModalTicket = () => {
        setVisibleTicket(true);
    };

    const hideModalTicket = () => {
        setVisibleTicket(false);
    };

    const [showAlert, setShowAlert] = useState(false);
    const [showAlert2, setShowAlert2] = useState(false);


    // ? CREATE CASH
    const saveCreate = async () => {


        if (formCash.capture_amount === "" && _type_client !== "https://insan.helen-sw.com2") {
            setShowAlert(true);
            return;
        }

        setLoadingCreate(true);
        let _arrayNew = amountfin[0] ?? 0;
        let _e = "EFECTIVO";
        let _notAmount = _arrayNew[_e];
        let _valid = _arrayNew[_e]?.Amount;

        // ? CONFIGURATION TYPE CLIENT
        let _valid_amount = _type_client === "https://insan.helen-sw.com2" ? _valid : formCash.capture_amount;

        if (
            _type_client === "https://cedimi.helen-sw.com" &&
            (parseFloat(formCash.capture_amount) < 0 ||
                (parseFloat(formCash.capture_amount) < (_valid - (_valid * 0.1)) && parseFloat(formCash.capture_amount) !== 0) ||
                parseFloat(formCash.capture_amount) > _valid)
        ) {

            setLoadingCreate(false);
            setShowAlert2(true);
            return;
        }
        const viewCash = await createCash(formCash.comments, _notAmount, _valid, _valid_amount, orderFirst, orderLast, id_branch);

        if (viewCash > 0) {
            setLoadingCreate(false);
            setIdCashFlow(viewCash);
            showToastAlert("success", "Corte de caja", "El corte de caja se realizo correctamente.");
            updateCash();
            hideModalTicket()
            handleHistoric(true)

        } else {
            setLoadingCreate(false);
            createSweet("warning", "warning", "No se generó correctamente el corte");
        }
    };

    const updateCash = () => {
        handleUpdateValuesCash({
            capture_amount: 0,
            input2: "",
            input3: "",
            input4: "",
            comments: ""
        })
        setViewTab(1);
        getAmount();
        setTypeAmoun([]);
        setAmountfin([]);
    }

    // ? PRINT TICKET
    const printTicket = async (id_cash_flow, _valid, _is_extemporaneous) => {
        if (id_cash_flow > 0) {
            setLoadingPrint(true);
            setLoadingReport(true);

            let token = localStorage.getItem("token");

            let _valid_url = _is_extemporaneous
                ? `/api/CashFlow/PrintTicket/${id_cash_flow}?mount_cancel=${dataDevolution}&is_extemporaneous=true`
                : `/api/CashFlow/PrintTicket/${id_cash_flow}?mount_cancel=${dataDevolution}`;

            await fetch(ConfigServer.serverUrl + _valid_url, {
                method: "GET",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
            })
                .then((response) => {
                    console.log("🚀 ~ printTicket ~ response:", response);

                    if (response.status !== 200) {
                        if (response.status === 409) {
                            showToastAlert("success", "Corte de caja", "No se puede imprimir cortes de dias pasados.");
                        } else {
                            showToastAlert("success", "Recibo", "No se genero correctamente el ticket.");

                        }

                        throw new Error("Respuesta inválida");
                    }

                    if (_valid) {
                        toggleModalPrint();
                    }

                    return response.blob();
                })
                .then((blob) => {
                    if (!blob) return;

                    var url = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "ticket.pdf");
                    document.body.appendChild(link);
                    link.style.display = "none";
                    link.click();

                    setIdCashFlow(0);
                })
                .catch((error) => {
                    console.log("🚀 ~ printTicket ~ error:", error);
                })
                .finally(() => {
                    setLoadingPrint(false);
                    setLoadingReport(false);
                });
        }
    };

    // ? DOWNLOAD  CREDITS
    const downloadExcel = async (_idCash) => {
        if (_type_client !== "https://cedimi.helen-sw.com") {
            return;
        }
        let token = localStorage.getItem("token");
        await fetch(ConfigServer.serverUrl + `/api/WorkOrder/DownloadWorkOrderPaymentsCredits/${_idCash}`, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/vnd.ms-excel"
            })
        })
            .then(response => {
                if (response.status !== 200) {
                    showToastAlert("warning", "Ticket", "No se genero correctamente.");
                    return;
                }

                return response.blob();
            })
            .then(blob => {
                var url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Reporte Credito.xlsx");

                document.body.appendChild(link);
                link.style.display = 'none';
                link.click();
            });
    }

    // ? OTHER 
    const downloadExcelCredits = async (_idCash) => {
        if (_type_client !== "https://cedimi.helen-sw.com") {
            return;
        }

        setLoadingReport(true);

        let token = localStorage.getItem("token");
        try {
            const response = await fetch(ConfigServer.serverUrl + `/api/WorkOrder/DownloadWorkOrderPaymentsCredits/${_idCash}`, {
                method: 'GET',
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/vnd.ms-excel"
                })
            });

            if (response.status !== 200) {
                createSweet("warning", "warning", "No se descargo el archivo excel");
                setLoadingReport(false);
                return;
            }

            const blob = await response.blob();
            var url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Reporte Saldo.xlsx");

            document.body.appendChild(link);
            link.style.display = 'none';
            link.click();

        } catch (error) {
            showToastAlert("warning", "Corte", "Ocurrió un error al descargar el archivo.");

        } finally {
            setLoadingReport(false);
        }
    };


    const downloadExcelOthers = async (_idCash) => {
        if (_type_client !== "https://cedimi.helen-sw.com") {
            return;
        }

        setLoadingReport(true);

        let token = localStorage.getItem("token");
        try {
            const response = await fetch(ConfigServer.serverUrl + `/api/WorkOrder/DownloadWorkOrderPaymentsOthers/${_idCash}`, {
                method: 'GET',
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/vnd.ms-excel"
                })
            });

            if (response.status !== 200) {
                showToastAlert("warning", "Corte", "No se descargo el archivo excel.");
                setLoadingReport(false);
                return;
            }

            const blob = await response.blob();
            var url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Reporte Contado.xlsx");

            document.body.appendChild(link);
            link.style.display = 'none';
            link.click();

        } catch (error) {
            showToastAlert("warning", "Corte", "Ocurrió un error al descargar el archivo.");
        } finally {
            setLoadingReport(false);
        }

    }


    const handleHistoric = async (filters = false) => {
        let _body = {};
        if (filters === false) {
            _body = {
                "date_init": "",
                "date_end": "",
                "type": "all"
            }
        } else {
            _body = {
                "date_init": dateInit,
                "date_end": dateEnd,
                "type": "filter"
            }
        }
        let _listTemp = await handleRequest("POST", "WorkOrder/DetailCash", "cash", _body);

        if (_listTemp !== null) {
            setDataHistoric([..._listTemp]);
        } else {
            setDataHistoric([]);
        }
    }

    const changeDate = (data, type) => {
        let _fecha = new moment(data._d).format('YYYY-MM-DD');
        if (type === "init") {
            setDateInit(_fecha)
        } else {
            setDateEnd(_fecha)
        }
    }

    const parseDateLocal = (dateString) => {
        const [year, month, day] = dateString.split("-").map(Number);
        return new Date(year, month - 1, day);
    };


    //*METHOD FINAL REPORT
    const getReport = (e, search = true) => {
        e.preventDefault();

        if (search) {
            if (!mDateRange1) {
                showToastAlert("warning", "Reporte Global", "Seleccione una fecha de inicio.");

                return;
            }
            if (!mDateRange2) {
                showToastAlert("warning", "Reporte Gloabl", "Seleccione una fecha de cierre.");
                return;
            }

            let query = "";
            let _mfrom = (mDateRange1) ? moment(mDateRange1).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            let _mto = (mDateRange2) ? moment(mDateRange2).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            let _idBranch = mSelectBranch.value;
            let _typeUser = type_company == null ? null : type_company.value;
            let _idUser = ids_users.value;

            const start = parseDateLocal(_mfrom);
            const end = parseDateLocal(_mto);


            if (_type_client === pyrsa) {

                const monthDifference = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());

                if (monthDifference > 5) {
                    showToastAlert(
                        "warning",
                        "Reporte Global",
                        "Solo puedes filtrar un máximo de 6 meses."
                    );
                    return;
                }

            } else if (
                _type_client === insan ||
                _type_client === semlab ||
                _type_client === almas ||
                _type_client === labcen ||
                _type_client === qfb ||
                _type_client === phersu
            ) {

                const monthDifference = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());

                if (monthDifference > 7) {
                    showToastAlert(
                        "warning",
                        "Reporte Global",
                        "Solo puedes filtrar un máximo de 8 meses."
                    );
                    return;
                }

            } else {

                if (start.getFullYear() !== end.getFullYear() || start.getMonth() !== end.getMonth()) {
                    showToastAlert(
                        "warning",
                        "Reporte Global",
                        "Solo puedes filtrar un único mes."
                    );
                    return;
                }
            }





            if (_mfrom !== "") {
                query += `${_idBranch}?date_from=${_mfrom}`;
            }

            if (_mto !== "") {
                query += `&date_to=${_mto}`;
            }

            if (_idBranch !== "" && _mfrom === "") {
                query += `${_idBranch}`;
                console.log("-");
            }

            if (type_company !== null && _mfrom.length === 0 && _mto.length === 0) {
                //  query += `?type_company=${_typeUser}`;   
                console.log("?");
            }

            if (type_company == null || _mfrom.length !== 0 || _mto.length !== 0) {
                if (_typeUser > 0) {
                    query += `&type_company=${_typeUser}`;
                    console.log("====");

                }
                else {
                    if (_idUser === undefined) {
                    }
                    else {
                        console.log("aqui pasa?3");
                        query += `&id_user=${_idUser}`;
                        setDataUser([{ "value": 0, "label": "Todos" }])
                    }
                }
            }

            //  if (type_company !== null || _mfrom.length === 0  || _mto.length === 0 ) {
            //     query += `&type_company=${_typeUser}`;  
            //     console.log("hhh");

            //  }
            getDetailCreditCash(true, query)
        }
    }


    //*END METHOD FINAL REPORT
    const getDetailCreditCash = async (_search = false, _filter) => {

        setLoading(true);
        var _listTmp = {};
        let _alterUrl = "";

        if (_search === false) {
            _listTmp = await handleRequest("GET", `WorkOrder/DetailCreditCash/${id_branch}` + _alterUrl, "Report");
        } else {
            _listTmp = await handleRequest("GET", `WorkOrder/DetailCreditCash/` + _filter, "Report");
        }


        if (_listTmp !== null) {

            setLoading(false);

            let _arrayNew = [];
            let startItems = 0;
            let endItems = numberCash;
            let aux = numberCash * currentPage1;

            endItems = aux;
            startItems = endItems - numberCash;

            // * LIST PAYMETHODS
            let _amountGlobal = [
                {
                    id_pay_method: 1,
                    pay_method: "EFECTIVO",
                    amount: 0
                },
                {
                    id_pay_method: 2,
                    pay_method: "TARJETA DE CRÉDITO",
                    amount: 0
                },
                {
                    id_pay_method: 4,
                    pay_method: "TARJETA DE DÉBITO",
                    amount: 0
                },
                {
                    id_pay_method: 8,
                    pay_method: "TRANSFERENCIA ELECTRÓNICA DE FONDOS",
                    amount: 0
                },
                {
                    id_pay_method: 28,
                    pay_method: "FICHA DE DEPOSITO",
                    amount: 0
                },
                {
                    id_pay_method: 10,
                    pay_method: "CREDITO",
                    amount: 0
                },
                {
                    id_pay_method: 31,
                    pay_method: "BONIFICACION",
                    amount: 0
                }
            ];


            let decimals = 2;
            const companyNamesMap = {};

            _listTmp.workOrderDetailCash.forEach(
                (_find, _key) => {

                    // ! SERIE B
                    const isBonificacionCC = _valid_Finance === "True" && _finance2 === "False" && _type_client === "https://cedimi.helen-sw.com" && _find.complete_information === "True" && _find.nameMethod === "EFECTIVO";

                    console.log("🚀 ~ getDetailCreditCash ~ isBonificacionCC:", isBonificacionCC);

                    let posicion = _key + 1;
                    let visibleTable = posicion > startItems && posicion <= endItems;

                    if (_find.id_user !== null && _find.id_user !== 0) {

                        const companyName = _find.user;

                        if (!companyNamesMap.hasOwnProperty(companyName)) {

                            companyNamesMap[companyName] = true;

                            const nuevo = { value: _find.id_user, label: companyName };

                            setDataUser(
                                prevDataUser => [
                                    ...prevDataUser,
                                    nuevo
                                ]
                            );
                        }
                    }


                    let {
                        nameMethod,
                        amount,
                        nim,
                        fech,
                        name,
                        company,
                        status,
                        user,
                        abreviationName,
                        abreviationPaternal,
                        abreviationMaternal,
                        id_user,
                        ajuste,
                        paid,
                        fech_Adjust,
                        fech_admision,
                        complete_information,
                        name_company,
                        is_invoice,
                        name_branches,
                        name_Preloaded_discount,
                        percentagePreloaded_discount,
                        id_company,
                        required_invoice,
                        flow_b,
                        rfc_receptor,
                        name_receptor,
                        folio_invoice,
                        emission_date_invoice,
                        age,
                        is_micro,
                        doctorName,
                        doctorCode,
                        seller,
                        priceDetails,
                        qc_reason,
                        name_agreenent
                    } = _find;

                    let payment = {
                        creditCard: nameMethod === "TARJETA DE CRÉDITO" ? amount : 0,
                        cash: nameMethod === "EFECTIVO" ? (isBonificacionCC ? 0 : amount) : 0,
                        debitCard: nameMethod === "TARJETA DE DÉBITO" ? amount : 0,
                        electronicTransfer: nameMethod === "TRANSFERENCIA ELECTRÓNICA DE FONDOS" ? amount : 0,
                        credit: nameMethod === "CREDITO" ? amount : 0,
                        deposit: nameMethod === "FICHA DE DEPOSITO" ? amount : 0,
                        bonificacion: isBonificacionCC ? amount : (nameMethod === "BONIFICACION" ? amount : 0)
                    };

                    let existingOrderIndex = _arrayNew.findIndex(objeto => objeto.nim === _find.nim);

                    if (existingOrderIndex !== -1) {
                        if (!_find.ajuste) {
                            _arrayNew[existingOrderIndex].amount += amount;
                        }

                        Object.keys(payment).forEach(
                            method => {
                                if (
                                    _arrayNew[existingOrderIndex][method] === undefined
                                ) {
                                    _arrayNew[existingOrderIndex][method] = 0;
                                }
                                _arrayNew[existingOrderIndex][method] += payment[method];
                            }
                        );

                        // * SERIE B
                        if (isBonificacionCC) {
                            _arrayNew[existingOrderIndex].method = "BONIFICACIÓN CC";
                            _arrayNew[existingOrderIndex].isBonificacionCC = true;
                        }

                    } else {

                        _arrayNew.push({
                            ...payment,
                            nim,
                            hour: fech,
                            namePatiente: name,
                            name_branches: name_branches,
                            type: company ? "Empresas" : "Público General",
                            status: status === 0 ? "Cancelado" : "Vigente",
                            method: isBonificacionCC ? "BONIFICACIÓN CC" : nameMethod,
                            amount: !_find.ajuste ? amount : 0,
                            user,
                            id_user,
                            is_fullPaid: paid === false ? "PENDIENTE" : "LIQUIDADO",
                            visibleTable,
                            is_adjustP: _find.is_adjustP,
                            abreviationName,
                            abreviationPaternal,
                            abreviationMaternal,
                            gatos: _find.status === 0 ? 0 : 1,
                            nameUserAdjust: _find.nameUserAdjust,
                            nameCommont: _find.nameCommont,
                            amountDiscount: company ? "" : _find.amountDiscount,
                            amountPercentag1: _find.amountPercentag1,
                            codeD: _find.codeD,
                            amountPercentag: _find.amountPercentag,
                            ajuste,
                            paid,
                            fech_Adjust,
                            fech_admision,
                            complete_information,
                            name_company,
                            is_invoice,
                            name_Preloaded_discount,
                            percentagePreloaded_discount,
                            id_company,
                            required_invoice,
                            flow_b,
                            isBonificacionCC,
                            rfc_receptor,
                            name_receptor,
                            folio_invoice,
                            emission_date_invoice,
                            age,
                            is_micro,
                            doctorName,
                            doctorCode,
                            seller,
                            priceDetails,
                            typeClientUser: _find.is_micro ? (company ? name_company : name) : name,
                            qc_reason,
                            name_agreenent
                        });
                    }


                    Object.keys(payment).forEach(
                        method => {
                            if (_find.status === 0) {
                                return;
                            }

                            let id_pay_method = _find.id_pay_method;
                            let methodAmount = payment[method];

                            if (!_find.company) {

                                if (id_pay_method === 10 && _find.is_fullPaid) {
                                    return;
                                }
                            }

                            if (isBonificacionCC) {

                                if (method !== "cash") {
                                    return;
                                }

                                let bonificacionIndex = _amountGlobal.findIndex(item => item.id_pay_method === 31);

                                if (bonificacionIndex !== -1) {
                                    _amountGlobal[bonificacionIndex].amount += amount;
                                }
                                return;
                            }

                            let globalIndex = _amountGlobal.findIndex(item => item.id_pay_method === id_pay_method);

                            if (globalIndex !== -1) {
                                _amountGlobal[globalIndex].amount += methodAmount;
                            }
                        }
                    );
                }
            );

            let _totalCancell =
                _arrayNew.reduce(
                    (total, _movement) => {
                        return _movement.status === "Cancelado" ? total + _movement.amount : total;
                    },
                    0
                );


            let _totalDiscount =
                _arrayNew.reduce(
                    (total, _f) => {

                        let _finA = _f.amountDiscount;

                        if (_finA !== 0 && _finA !== "" && _finA !== null) {
                            return total + _f.amountDiscount;

                        } else {
                            return total;
                        }
                    },
                    0
                );

            let _totalGlobalMovements =
                _amountGlobal.reduce(
                    (total, _find) => {

                        if (_find.id_pay_method === 31) {
                            return total;
                        }
                        return total + _find.amount;
                    },
                    0
                );


            let _subtotal_ = _totalGlobalMovements;
            _subtotal_ = parseFloat(_subtotal_.toFixed(decimals));

            console.log("🚀 ARRAY FINAL:", _arrayNew);
            console.log("🚀 MÉTODOS DE PAGO:", _amountGlobal);



            const totalBonificacionCC = _arrayNew.reduce(
                (total, item) => {

                    if (
                        !item.isBonificacionCC ||
                        item.status !== "Vigente"
                    ) {
                        return total;
                    }

                    return total + Number(
                        item.bonificacion ?? 0
                    );
                },
                0
            );


            console.log(
                "🚀 TOTAL BONIFICACIÓN CC VIGENTE:",
                totalBonificacionCC
            );


            setDataReport(_arrayNew);
            setDataPaymets(_amountGlobal);
            setDataCancell(_totalCancell);
            setDataMDiscount(_totalDiscount);
            setDataDiscount(_listTmp.total_discount);
            setDataPatient(_listTmp.total_patien);
            setTotal_devolution(_listTmp.total_devolution);
            setTotalPaymets(_subtotal_);
            setDataBonificacionCC(totalBonificacionCC);
        }
    };

    const handleClean = () => {

        handleUpdateValuesCash({
            mDateRange1: "",
            mDateRange2: "",
            type_company: null,
            mSelectBranch: 1
        });
        getDetailCreditCash(false)
    }


    //* PAGINATION FINAL REPORT
    const { totalPageCount1, currentPage1, nextPage1, previousPage1, goToPage1 } = usePaginationCash(dataReport.length, numberCash);

    useEffect(() => {

        let startItems = 0;
        let endItems = numberCash;
        let aux = numberCash * currentPage1;

        endItems = aux;

        startItems = endItems - numberCash;

        let listTmp = [];

        dataReport.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listTmp.push({
                ...data,
                visibleTable:
                    visibleTable
            });
        });

        setDataReport(listTmp);
    }, [totalPageCount1, currentPage1]);


    //*PDF FINAL REPORT 
    const printCashClosing = async () => {

        let valuesBranch = formCash.mSelectBranch
        let nameBranch = valuesBranch.label

        const modifiedDataReport = dataReport.map((_find, _key) => {
            if (_validationFinance) {
                let _b = _validationFinance ? (_key + 1) : _find.nim;
                return { ..._find, nim: _b };
            }
            return null;
        }).filter(item => item !== null);

        let data = {
            workOrderDetailCash: _validationFinance ? modifiedDataReport : dataReport,
            listMovements: dataPaymets,
            total_devolution: dataCancell,
            total_discount: dataDiscount,
            total_patien: dataPatient,
            name_branch: nameBranch,
            date_cash: mDateRange1,
            amount_global: totalPaymets,
            amount_discount: dataMDiscount.toFixed(2)
        };

        data.workOrderDetailCash.forEach(workOrderCash => {
            if (workOrderCash.status === "Cancelado") {
                workOrderCash.status = 0;
            } else {
                workOrderCash.status = 1;
            }

            if (workOrderCash.is_fullPaid === "PENDIENTE") {
                workOrderCash.is_fullPaid = false;
            } else {
                workOrderCash.is_fullPaid = true;
            }
        })

        let raw = JSON.stringify(data);
        let token = localStorage.getItem("token");

        await fetch(ConfigServer.serverUrl + "/api/CashFlow/PrintCashClosing", {
            method: 'POST',
            body: raw,
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {

                if (response.status !== 200) {
                    showToastAlert("warning", "Reporte", "No se descargo el PDF.");

                    return;
                }

                return response.blob();
            })
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Corte de Caja.pdf")
                document.body.appendChild(link);
                link.style.display = 'none';
                link.click();
            });
    }


    // * REPORT GLOBAL ALL EXAMS   

    function exportToExcel(nimDataExcel) {
        console.log("🚀 ~ exportToExcel ~ nimDataExcel:", nimDataExcel);

        let _Report = [];
        let _array = nimDataExcel;
        let totalAmount = 0;

        _array.forEach((_find, key) => {

            let _a = _validationFinance ? "Solicitud(NIM)" : "Solicitud(NIM)";

            let _b = _validationFinance ? _find.nim : _find.nim;

            let _new_amount = _find.status === "Cancelado" ? 0
                : ((_find.amount ?? 0) - (_find?.bonificacion ?? 0));

            totalAmount += _new_amount;


            const estudios =
                Array.isArray(_find.priceDetails) &&
                    _find.priceDetails.length > 0
                    ? _find.priceDetails
                    : [
                        {
                            name: "Sin estudio"
                        }
                    ];


            if (_find.flow_b === true) {
                var string = _find.namePatiente;
                var words = string.split(" ");
                var firstTwoWords = words.slice(0, 2).join(" ");
                _find.namePatiente = firstTwoWords;

            } else {



            }

            estudios.forEach((estudio, idx) => {

                const isFirst = idx === 0;


                const reportObject = {

                    // * PINTAR COLUMNA
                    _isFlowB: _find?.flow_b === true,
                    [_a]: isFirst ? _b : "",
                    ...(isFirst && _type_client !== "https://cedimi.helen-sw.com" ? { "Tipo": _find.is_micro ? "Microsanitaria" : "Clínico" } : {}),
                    "Fecha": isFirst ? _find.fech_admision : "",
                    "Hora": isFirst ? _find?.hour : "",
                    "Sucursal": isFirst ? _find.name_branches : "",
                    "Razón Social de la factura": isFirst ? _find.name_receptor : "",
                    "RFC": isFirst ? _find.rfc_receptor : "",
                    "Serie-Folio": isFirst ? _find?.folio_invoice : "",
                    "Fecha y Hora de emisión": isFirst ? _find?.emission_date_invoice : "",
                    "Efectivo": isFirst ? (_find?.cash ?? 0) : "",
                    "Credito": isFirst ? (_find?.credit ?? 0) : "",
                    "Tarjeta de Crédito": isFirst ? (_find?.creditCard ?? 0) : "",
                    "Tarjeta de Debito": isFirst ? (_find?.debitCard ?? 0) : "",
                    "Transferencia": isFirst ? (_find?.electronicTransfer ?? 0) : "",
                    ...(!_validationFinance ? {
                        "Bonificación": isFirst ? (_find?.bonificacion ?? 0) : ""
                    } : {}),
                    ...(_type_client === "https://cedimi.helen-sw.com" && _validationFinance ? { "Control de calidad": isFirst ? (_find?.bonificacion ?? 0) : "" } : {}),
                    "Total orden": isFirst ? _new_amount : "",
                    "Pendiente a Facturar": isFirst ? _find?.required_invoice : "",
                    "Facturado": isFirst ? (_validationFinance && _find?.flow_b === true ? "No" : (_find?.is_invoice === "Pendiente" ? "No" : "Si")) : "",
                    ...(isFirst && _validationFinance ? { "Cancelación CC": _find.flow_b ? "Si" : "No" } : {}),
                    ...(_validationFinance ? { "Observación de control de calidad": _find.qc_reason ?? "N/A" } : {}),
                    ...(!_validationFinance ? {
                        "Tipo de descuento": isFirst
                            ? (_find?.name_Preloaded_discount || _find?.nameCommont || "N/A")
                            : ""
                    } : {}),
                    "Edad": isFirst ? (_find?.age ? `${_find.age} años` : "Edad no disponible") : "",
                    ...(!_validationFinance ? {
                        "Porcentaje de descuento": isFirst
                            ? (_find?.percentagePreloaded_discount || _find?.amountPercentag || "N/A")
                            : ""
                    } : {}),
                    "Usuario que realizo admisión": isFirst ? _find?.user : "",
                    "Usuario que realizo recuperación": isFirst ? _find?.nameUserAdjust : "",
                    "Estatus": (_validationFinance && _find?.flow_b === true) ? "" : _find?.status,
                    "Nombre": isFirst ? (_find.is_micro ? (_find?.type === "Empresas" ? _find?.name_company : _find?.namePatiente) : _find?.namePatiente) : "",
                    "Médico": _find?.doctorName || "",
                    ...(isFirst && _type_client === "https://cedimi.helen-sw.com" ? { "No. Colegiado": _find?.doctorCode } : {}),
                    "Compañia": isFirst ? (_find?.type || "Público General") : "",
                    ...(isFirst && _type_client === "https://pyrsa.helen-sw.com" ? { "Convenio": (_find?.type === "Empresas" ? _find?.name_agreenent : "N/A") } : {}),
                    "Nombre de la empresa": isFirst ? (_find?.type === "Empresas" ? _find?.name_company : "N/A") : "",
                    ...(isFirst && _type_client === "https://cedimi.helen-sw.com" ? { "Vendedor": _find?.seller } : {}),
                    "Estudio": estudio.name || "Sin estudio",
                    "Subtotal": estudio.price || 0,
                    "IVA": estudio.price_tax || 0,
                    "Descuento": (_valid_Finance && _find?.flow_b === true) ? 0 : estudio.total_discount || 0,
                    "Urgencia": estudio.price_urgent || 0,
                    "Total": Number(estudio.total || 0),
                    "Estatus del estudio": (_valid_Finance && _find?.flow_b === true ? "" : estudio.status_exam || "N/A"),
                    // (_validationFinance && _find?.flow_b === true) ? "" : _find?.status,

                    ...(isFirst && _type_client === "https://labcen.helen-sw.com" ? { "Estado de pago": _find?.is_fullPaid } : {})
                };
                _Report.push(reportObject);
            });
        });



        const exportReport = _Report.map(item => {

            const { _isFlowB, ...rest } = item;

            return rest;
        });

        const worksheet = XLSX.utils.json_to_sheet(exportReport);
        const range = XLSX.utils.decode_range(worksheet["!ref"]);

        // ! STYLE 

        for (let col = range.s.c; col <= range.e.c; col++) {

            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
            const cell = worksheet[cellAddress];

            if (cell) {

                cell.s = {

                    fill: {
                        patternType: "solid",
                        fgColor: {
                            rgb: "1B658B"
                        }
                    },

                    font: {
                        bold: true,
                        color: {
                            rgb: "FFFFFF"
                        }
                    },

                    alignment: {
                        horizontal: "center",
                        vertical: "center"
                    },

                    border: {

                        top: {
                            style: "thin",
                            color: {
                                rgb: "D9E2F3"
                            }
                        },

                        bottom: {
                            style: "thin",
                            color: {
                                rgb: "D9E2F3"
                            }
                        },

                        left: {
                            style: "thin",
                            color: {
                                rgb: "D9E2F3"
                            }
                        },

                        right: {
                            style: "thin",
                            color: {
                                rgb: "D9E2F3"
                            }
                        }
                    }
                };
            }
        }

        _Report.forEach((reportItem, index) => {

            if (_validationFinance && reportItem?._isFlowB) {

                const excelRow = index + 1;


                for (
                    let col = range.s.c;
                    col <= range.e.c;
                    col++
                ) {

                    const cellAddress =
                        XLSX.utils.encode_cell({
                            r: excelRow,
                            c: col
                        });


                    let cell = worksheet[cellAddress];


                    if (!cell) {

                        worksheet[cellAddress] = {
                            t: "s",
                            v: ""
                        };

                        cell =
                            worksheet[cellAddress];
                    }


                    cell.s = {

                        fill: {
                            patternType: "solid",
                            fgColor: {
                                rgb: "D9EAF7"
                            }
                        },

                        font: {
                            color: {
                                rgb: "1B4F72"
                            }
                        },

                        border: {

                            top: {
                                style: "thin",
                                color: {
                                    rgb: "B8CCE4"
                                }
                            },

                            bottom: {
                                style: "thin",
                                color: {
                                    rgb: "B8CCE4"
                                }
                            },

                            left: {
                                style: "thin",
                                color: {
                                    rgb: "B8CCE4"
                                }
                            },

                            right: {
                                style: "thin",
                                color: {
                                    rgb: "B8CCE4"
                                }
                            }
                        }
                    };
                }
            }
        });

        // ! COLOCAR ANCHO DE LAS COLUMNAS

        worksheet["!cols"] =
            exportReport.length > 0
                ? Object.keys(
                    exportReport[0]
                ).map(column => {

                    if (
                        column === "Razón Social de la factura"
                    ) {
                        return {
                            wch: 28
                        };
                    }

                    if (
                        column === "Fecha y Hora de emisión"
                    ) {
                        return {
                            wch: 23
                        };
                    }

                    if (
                        column === "Usuario que realizo admisión"
                    ) {
                        return {
                            wch: 28
                        };
                    }

                    if (
                        column === "Usuario que realizo recuperación"
                    ) {
                        return {
                            wch: 30
                        };
                    }

                    if (
                        column === "Nombre de la empresa"
                    ) {
                        return {
                            wch: 28
                        };
                    }

                    if (
                        column === "Nombre"
                    ) {
                        return {
                            wch: 30
                        };
                    }

                    if (
                        column === "Estudio"
                    ) {
                        return {
                            wch: 35
                        };
                    }

                    if (
                        column === "Médico"
                    ) {
                        return {
                            wch: 28
                        };
                    }

                    return {
                        wch: 18
                    };
                })
                : [];



        const workbook = XLSX.utils.book_new();


        XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte");
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });


        const dataBlob =
            new Blob(
                [excelBuffer],
                {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                }
            );


        const fileName = "Reporte Global con estudios.xlsx";


        if (typeof window !== "undefined" && window.navigator?.msSaveOrOpenBlob) {

            window.navigator.msSaveOrOpenBlob(dataBlob, fileName);

        } else {

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");

            link.href = url;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        }
    }

    // * REPORT GLOBAL WITHOUT EXAMS   
    function exportToExcelWithoutExams(nimDataExcel) {

        let _Report = [];
        let _array = nimDataExcel;
        let totalAmount = 0;

        _array.forEach((_find, key) => {

            let _a = _validationFinance ? "Solicitud(NIM)" : "Solicitud(NIM)";
            console.log("🚀 ~ exportToExcelWithoutExams ~ _validationFinance:", _validationFinance)
            let _b = _validationFinance ? (key + 1) : _find.nim;
            let _new_amount = _find.status === "Cancelado" ? 0 : (_find.amount ?? 0);

            totalAmount += _new_amount;

            let reportObject = {

                _isFlowB: _find?.flow_b === true,
                [_a]: _find.nim,
                ...(_type_client !== "https://cedimi.helen-sw.com" ? { "Tipo": _find.is_micro ? "Microsanitaria" : "Clínico" } : {}),
                "Fecha": _find.fech_admision,
                "Hora": _find?.hour,
                "Sucursal": _find.name_branches,
                "Razón Social de la factura": _find.name_receptor,
                "RFC": _find.rfc_receptor,
                "Serie-Folio": _find?.folio_invoice,
                "Fecha y Hora de emisión": _find?.emission_date_invoice,
                "Efectivo": _find?.cash ?? 0,
                "Credito": _find?.credit ?? 0,
                "Tarjeta de Crédito": _find?.creditCard ?? 0,
                "Tarjeta de Debito": _find?.debitCard ?? 0,
                "Transferencia": _find?.electronicTransfer ?? 0,
                ...(!_validationFinance ? {
                    "Bonificación": (_find?.bonificacion ?? 0)
                } : {}),

                ...(_type_client === "https://cedimi.helen-sw.com" && _validationFinance ? { "Control de calidad": _find?.bonificacion ?? 0 } : {}),
                "Total": _new_amount,
                "Pendiente a Facturar": _find?.required_invoice,
                "Facturado": (_validationFinance && _find?.flow_b) === true ? "No" : (_find?.is_invoice === "Pendiente" ? "No" : "Si"),
                ...(_validationFinance ? { "Cancelación CC": _find.flow_b ? "Si" : "No" } : {}),
                ...(_validationFinance ? { "Observación de control de calidad": _find.qc_reason ?? "N/A" } : {}),
                ...(!_validationFinance ? {
                    "Tipo de descuento": _find?.name_Preloaded_discount !== ""
                        ? _find?.name_Preloaded_discount
                        : _find?.nameCommont !== ""
                            ? _find?.nameCommont
                            : "N/A"
                } : {}),
                "Edad": _find?.age ? `${_find.age} años` : "Edad no disponible",
                ...(!_validationFinance ? {
                    "Porcentaje de descuento": _find?.name_Preloaded_discount !== ""
                        ? _find?.percentagePreloaded_discount
                        : _find?.nameCommont !== ""
                            ? _find?.amountPercentag
                            : "N/A"
                } : {}),
                "Usuario que realizo admisión": _find?.user,
                "Usuario que realizo recuperación": _find?.nameUserAdjust,
                "Estatus": (_validationFinance && _find?.flow_b === true) ? "" : _find?.status,
                "Nombre": _find.is_micro ? (_find?.type === "Empresas" ? _find?.name_company : _find?.namePatiente) : _find?.namePatiente,
                ...(_type_client === "https://cedimi.helen-sw.com" ? { "Médico": _find?.doctorName } : {}),
                ...(_type_client === "https://cedimi.helen-sw.com" ? { "No. Colegiado": _find?.doctorCode } : {}),
                "Compañia": _find?.type,
                "Nombre de la empresa": _find?.type === "Empresas" ? _find?.name_company : "N/A",
                ...(_type_client === "https://pyrsa.helen-sw.com" ? { "Convenio": (_find?.type === "Empresas" ? _find?.name_agreenent : "N/A") } : {}),
                ...(_type_client === "https://cedimi.helen-sw.com" ? { "Vendedor": _find?.seller } : {}),
                ...(_type_client === "https://labcen.helen-sw.com" ? { "Estado de pago": _find?.is_fullPaid } : {})
            };
            _Report.push(reportObject);
        });


        const exportReport = _Report.map(item => {

            const { _isFlowB, ...rest } = item;

            return rest;
        });


        let totalRow = {
            "Solicitud(NIM)": "",
            ...(_type_client !== "https://cedimi.helen-sw.com"
                ? { "Tipo": "" }
                : {}),
            "Fecha": "",
            "Hora": "",
            "Sucursal": "",
            "Razón Social de la factura": "",
            "RFC": "",
            "Serie-Folio": "",
            "Fecha y Hora de emisión": "",

            "Efectivo": "",
            "Credito": "",
            "Tarjeta de Crédito": "",
            "Tarjeta de Debito": "",
            "Transferencia": "",
            ...(
                (_type_client === "https://cedimi.helen-sw.com" &&
                    !_validationFinance)
                    ? { "Bonificación": "" }
                    : {}
            ),
            "Total": totalAmount,
            "Pendiente a Facturar": "",
            "Facturado": "",
            ...(_validationFinance
                ? {
                    "Cancelación CC": "",
                    "Observación de control de calidad": ""
                }
                : {}),

            ...(!_validationFinance
                ? {
                    "Tipo de descuento": ""
                }
                : {}),

            "Edad": "",
            ...(!_validationFinance
                ? {
                    "Porcentaje de descuento": ""
                }
                : {}),
            "Usuario que realizo admisión": "",
            "Usuario que realizo recuperación": "",
            "Estatus": "",
            "Nombre": "",
            ...(_type_client === "https://cedimi.helen-sw.com"
                ? {
                    "Médico": "",
                    "No. Colegiado": ""
                }
                : {}),
            "Compañia": "",
            "Nombre de la empresa": "",
            ...(_type_client === "https://pyrsa.helen-sw.com"
                ? {
                    "Convenio": ""
                }
                : {}),
            ...(_type_client === "https://cedimi.helen-sw.com"
                ? {
                    "Vendedor": ""
                }
                : {}),
            ...(_type_client === "https://labcen.helen-sw.com"
                ? {
                    "Estado de pago": ""
                }
                : {})
        };
        exportReport.push(totalRow);


        const worksheet = XLSX.utils.json_to_sheet(exportReport);

        const range = XLSX.utils.decode_range(worksheet["!ref"]);


        for (
            let col = range.s.c;
            col <= range.e.c;
            col++
        ) {

            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
            const cell = worksheet[cellAddress];


            if (cell) {

                cell.s = {

                    fill: {
                        patternType: "solid",
                        fgColor: {
                            rgb: "1B658B"
                        }
                    },

                    font: {
                        bold: true,
                        color: {
                            rgb: "FFFFFF"
                        }
                    },

                    alignment: {
                        horizontal: "center",
                        vertical: "center"
                    },

                    border: {

                        top: {
                            style: "thin",
                            color: {
                                rgb: "D9E2F3"
                            }
                        },

                        bottom: {
                            style: "thin",
                            color: {
                                rgb: "D9E2F3"
                            }
                        },

                        left: {
                            style: "thin",
                            color: {
                                rgb: "D9E2F3"
                            }
                        },

                        right: {
                            style: "thin",
                            color: {
                                rgb: "D9E2F3"
                            }
                        }
                    }
                };
            }
        }



        _Report.forEach((reportItem, index) => {

            if (_validationFinance && reportItem?._isFlowB) {

                const excelRow = index + 1;


                for (
                    let col = range.s.c;
                    col <= range.e.c;
                    col++
                ) {

                    const cellAddress = XLSX.utils.encode_cell({ r: excelRow, c: col });

                    let cell = worksheet[cellAddress];


                    if (!cell) {

                        worksheet[cellAddress] = {
                            t: "s",
                            v: ""
                        };

                        cell =
                            worksheet[cellAddress];
                    }


                    cell.s = {

                        fill: {
                            patternType: "solid",
                            fgColor: {
                                rgb: "D9EAF7"
                            }
                        },

                        font: {
                            color: {
                                rgb: "1B4F72"
                            }
                        },

                        border: {

                            top: {
                                style: "thin",
                                color: {
                                    rgb: "B8CCE4"
                                }
                            },

                            bottom: {
                                style: "thin",
                                color: {
                                    rgb: "B8CCE4"
                                }
                            },

                            left: {
                                style: "thin",
                                color: {
                                    rgb: "B8CCE4"
                                }
                            },

                            right: {
                                style: "thin",
                                color: {
                                    rgb: "B8CCE4"
                                }
                            }
                        }
                    };
                }
            }
        });



        const totalExcelRow = exportReport.length;

        for (
            let col = range.s.c;
            col <= range.e.c;
            col++
        ) {

            const cellAddress =
                XLSX.utils.encode_cell({
                    r: totalExcelRow,
                    c: col
                });

            let cell =
                worksheet[cellAddress];

            if (!cell) {

                worksheet[cellAddress] = {
                    t: "s",
                    v: ""
                };

                cell =
                    worksheet[cellAddress];
            }

            cell.s = {


                font: {
                    bold: true,
                    color: {
                        rgb: "1B4F72"
                    }
                },

                border: {
                    top: {
                        style: "medium",
                        color: {
                            rgb: "1B658B"
                        }
                    }
                }
            };
        }



        if (exportReport.length > 0) {

            worksheet["!cols"] =
                Object.keys(
                    exportReport[0]
                ).map(column => {

                    if (
                        column === "Razón Social de la factura"
                    ) {
                        return {
                            wch: 28
                        };
                    }

                    if (
                        column === "Fecha y Hora de emisión"
                    ) {
                        return {
                            wch: 23
                        };
                    }

                    if (
                        column === "Usuario que realizo admisión"
                    ) {
                        return {
                            wch: 28
                        };
                    }

                    if (
                        column === "Usuario que realizo recuperación"
                    ) {
                        return {
                            wch: 30
                        };
                    }

                    if (
                        column === "Nombre"
                    ) {
                        return {
                            wch: 30
                        };
                    }

                    if (
                        column === "Nombre de la empresa"
                    ) {
                        return {
                            wch: 28
                        };
                    }

                    if (
                        column === "Médico"
                    ) {
                        return {
                            wch: 28
                        };
                    }

                    // if (
                    //     column === "Tipo de descuento"
                    // ) {
                    //     return {
                    //         wch: 23
                    //     };
                    // }

                    return {
                        wch: 18
                    };
                });
        }



        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

        const excelBuffer =
            XLSX.write(
                workbook,
                {
                    bookType: "xlsx",
                    type: "array"
                }
            );


        const dataBlob =
            new Blob(
                [excelBuffer],
                {
                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                }
            );


        const fileName = "Reporte Global sin estudios.xlsx";



        if (typeof window !== "undefined" && window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataBlob, fileName);

        } else {
            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");


            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);

            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
    }


    //*NUMBER FORMAT
    const number_format = (cantidad, decimals) => {
        cantidad += '';
        cantidad = parseFloat(cantidad.replace(/[^0-9\.]/g, ''));

        decimals = decimals || 0;

        if (isNaN(cantidad) || cantidad === 0) {
            return parseFloat(0).toFixed(decimals);
        }

        cantidad = '' + cantidad.toFixed(decimals);

        let cantidad_parts = cantidad.split('.'),
            regexp = /(\d+)(\d{3})/;

        while (regexp.test(cantidad_parts[0]))
            cantidad_parts[0] = cantidad_parts[0].replace(regexp, '$1' + ',' + '$2');

        return cantidad_parts.join('.');
    }

    //*FORMATTER
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    })

    // ? CONFIGURATION DATATABLE
    const exportToExcel2 = () => {
        const ws = XLSX.utils.json_to_sheet(dataUserReport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Ventas');
        XLSX.writeFile(wb, 'Detallado de venta.xlsx');
    };


    const getBadgePatient = (label) => {
        switch (label) {
            case 'Empresas':
                return 'success';
            case 'P.General':
                return 'warning';
            default:
                return 'secondary';
        }
    };

    const getBadgeStatus = (label) => {
        switch (label) {
            case "Cancelado":
                return 'danger';

            default:
                return 'success';
        }
    };

    const customBody = (rowData) => {
        return (
            <div style={{ display: "flex", justifyContent: "center" }}>
                <div
                    style={{
                        backgroundColor: "#f97316",
                        width: "110px",
                        height: "20px",
                        borderRadius: "8px",
                        color: "#fff",
                        fontSize: "10px",
                        paddingTop: "1px",
                        textAlign: "center",
                        cursor: "pointer"
                    }}
                    onClick={() => handleNim(rowData.id_work_order)}
                >
                    <i className="fa fa-angle-right f-12"></i>&nbsp;
                    <label className='f-w-600' style={{ fontSize: "10px" }}>
                        {rowData.nim ?? "------"}
                    </label>
                </div>
            </div>
        );
    };

    const handleNim = (_id_work_order) => {
        let value = "" + _id_work_order + "";
        history.push(`../../admisiones/${value}/editar`);
    };





    //*CONEXIÓN
    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 404) {

            createSweet("info", "info", "Atención", response.data.msg);
        }
        else if (response.code === 500) {
        }
        else {
        }
        return null;
    }

    const cancelTabChange = () => {

        setShowAlert(false);

    };
    const cancelTabChange2 = () => {

        setShowAlert2(false);

    };



    return {
        //*CONFIGURATION CASH
        navigatePrev, viewTab, formCash, capture_amount, handleInputChangeCash, loading,

        //*INDICATORS
        cancell, discountT, comments, saveCreate, formatter, totalCancell, totalPatients,

        //*HISTORIC
        dataHistoric, dateInit, dateEnd, changeDate, handleHistoric, previewCash, toggleCash, typeModal, modalC, typeAmoun, amountfin,

        //*FINAL REPORT
        dataReport, modalFullRef, handleReport, close, modalProps, totalPageCount1, currentPage1, nextPage1, previousPage1, goToPage1, dataPaymets, dataCancell,
        dataDiscount, dataPatient, dataDevolution, mDateRange1, mDateRange2, getReport, mSelectBranch, handleSelectValuesCash,
        printCashClosing, branches, totalPaymets, exportToExcel,

        //*FINAL REPORT TYPE COMPANY
        type_company, handleClean, dataMDiscount, dataUser, ids_users, number_format, sumPayMethods,

        //*PRINT TICKETS
        modalPrint, toggleModalPrint, handleViewTickets, printTicket, loadingPrint, loadingCreate,

        //*PREVIEW PRINT 
        modalPreview, toggleModalPreview, handleViewPreview, downloadExcel,

        // ? CONFIGURATION
        _type_client, total_devolution, downloadExcelCredits, downloadExcelOthers,

        dataUserReport,

        globalFilter, setGlobalFilter,

        _commercialLine, _nameUser, _branchName, excelExport, setExcelExport,
        loadingReport, exportToExcel2, getBadgePatient, getBadgeStatus, handleNim, customBody,
        visibleTicket, showModalTicket, hideModalTicket,
        exportToExcelWithoutExams,

        showAlert, cancelTabChange, showAlert2, cancelTabChange2,
        showToast, toastType, toastTitle, toastMessage, closeToastAlert,
        dataBonificacionCC



    }
}


